import { useMutation, useQuery } from "@apollo/client";
import { Grid, Stack, Title } from "@mantine/core";
import { useMediaQuery } from '@mantine/hooks';
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import AssetsTable from "../../components/assets/AssetsTable/AssetsTable";
import BalanceCard from "../../components/assets/BalanceCard/BalanceCard";
import PLTrend from "../../components/assets/PLTrend/PLTrend";
import AllocationCard from "../../components/assets/AllocationCard/AllocationCard";
import { CURRENT_USER } from "../../queries/auth";
import { ADD_LOG } from "../../queries/user-analytics";
import { logPageView} from "../../helpers/useGA"

export default function AssetsPage() {
  const { loading, error, data } = useQuery(CURRENT_USER);
  const [userid, setUserid] = useState(null);
  const isMobile = useMediaQuery('(max-width: 1090px)');
  const location = useLocation();
  const plTrendRef = useRef();
  const allocationRef = useRef();
  const [allocationTotal, setAllocationTotal] = useState(0);
  const loggedRouteKeyRef = useRef("");

      // added for tracking user data
      const [logEventMutation] = useMutation(ADD_LOG, {
        onCompleted: ({ addLog }) => {
          const { status, response } = addLog;
          if (status === 201) {
            console.log("Event logged successfully:", response);
            } else {
            console.error("Failed to log event:", response);
            }
        },
        onError: (error) => {
            console.error("Error logging event:", error.message);
        }
    });
  
      const logEvent = useCallback((eventType, additionalData, _userid) => {
        const eventData = {
            userid: Number(_userid),
            event_type: eventType,
            timestamp: new Date().toISOString(),
            additional_data: JSON.stringify(additionalData)
  
        };
  
        logEventMutation({ variables: eventData });
    }, [logEventMutation]);

  useEffect(() => {
      if (loading) console.log('Loading user...')
      else if (error) { setUserid(null) }
      else {
        const currentUserId = data?.currentUser?.userid;
        setUserid(currentUserId ?? null);

        const routeKey = `${currentUserId}:${location.pathname}${location.search}`;
        if (currentUserId && loggedRouteKeyRef.current !== routeKey) {
          logEvent("Assets Page", data, currentUserId);
          loggedRouteKeyRef.current = routeKey;
        }

        const pageTitle = "Assets Page";
        document.title = pageTitle; // Update document title
        logPageView(location.pathname + location.search, pageTitle);

      }
  }, [loading, error, data, location.pathname, location.search, logEvent])

  return (
    <Stack>
      <Title order={2}>Your Assets</Title>
      <Grid columns={24}>
        {!isMobile && <Grid.Col span={8}>
          <BalanceCard userid={userid} plTrendRef={plTrendRef} allocationRef={allocationRef} allocationTotal={allocationTotal} />
        </Grid.Col>}
        {isMobile && <Grid.Col span={24}>
          <BalanceCard userid={userid} plTrendRef={plTrendRef} allocationRef={allocationRef} allocationTotal={allocationTotal} />
        </Grid.Col>}
        {!isMobile && <Grid.Col span={16}>
          <PLTrend userid={userid} ref={plTrendRef} />
        </Grid.Col>}
        {isMobile && <Grid.Col span={24}>
          <PLTrend userid={userid} ref={plTrendRef} />
        </Grid.Col>}
        {!isMobile && <Grid.Col span={8}>
          <AllocationCard userid={userid} ref={allocationRef} onTotalChange={setAllocationTotal} />
        </Grid.Col>}
        {isMobile && <Grid.Col span={24}>
          <AllocationCard userid={userid} ref={allocationRef} onTotalChange={setAllocationTotal} />
        </Grid.Col>}
        {!isMobile && <Grid.Col span={16}>
          <AssetsTable walletid={userid} />
        </Grid.Col>}
        {isMobile && <Grid.Col span={24}>
          <AssetsTable walletid={userid} />
        </Grid.Col>}
      </Grid>
    </Stack>
  );
}
